import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from './store'

interface MediaState {
  mediaUri: string | null
  videoFile: File | null
  imageFile: File | null
  targetEmotion: { emotion: string; valence: number; arousal: number } | null
}

const initialState: MediaState = {
  mediaUri: null,
  videoFile: null,
  imageFile: null,
  targetEmotion: null,
}

const mediaSlice = createSlice({
  name: 'media',
  initialState,
  reducers: {
    setMediaUri: (state, action: PayloadAction<string | null>) => {
      state.mediaUri = action.payload
    },
    setVideoFile: (state, action: PayloadAction<File | null>) => {
      state.videoFile = action.payload
    },
    setImageFile: (state, action: PayloadAction<File | null>) => {
      state.imageFile = action.payload
    },
    resetMedia: state => {
      state.mediaUri = null
      state.videoFile = null
      state.imageFile = null
    },
    setTargetEmotion: (
      state,
      action: PayloadAction<{
        emotion: string
        valence: number
        arousal: number
      } | null>,
    ) => {
      state.targetEmotion = action.payload
    },
  },
})

export const { setMediaUri, setVideoFile, setImageFile, resetMedia, setTargetEmotion } =
  mediaSlice.actions

// Selector to get mediaUri from the store
export const selectMediaUri = (state: RootState) => state.media.mediaUri
export const selectVideoFile = (state: RootState) => state.media.videoFile
export const selectImageFile = (state: RootState) => state.media.imageFile
export const selectTargetEmotion = (state: RootState) =>
  state.media.targetEmotion

export default mediaSlice.reducer
